<app-dialog-container>
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div>
      <h1 mat-dialog-title>{{ title }}</h1>
    </div>
    <div>
      <button
        *ngIf="type === typeCesEnum.EDIT"
        mat-icon-button
        (click)="changeType(typeCesEnum.SHOW)"
      >
        <mat-icon class="btn-show">visibility</mat-icon>
      </button>
      <button
        *ngIf="type === typeCesEnum.SHOW"
        mat-icon-button
        (click)="changeType(typeCesEnum.EDIT)"
      >
        <mat-icon class="btn-edit">edit</mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="delete()"
        *ngIf="type !== typeCesEnum.NEW"
      >
        <mat-icon class="btn-delete">delete</mat-icon>
      </button>
    </div>
  </div>
  <dynamic-form
    [config]="config"
    #form="dynamicForm"
    [typeCes]="type"
    (onCancel)="onCancel()"
    (onSubmit)="onSubmit($event)"
  >
  </dynamic-form>
</app-dialog-container>
